import React from "react";
import { inject, observer } from "mobx-react";
import  { withStyles } from  '@material-ui/core/styles';
import SonicTable from '../../lib/SonicTable'
import CampaignBalanceDialog from './CampaignBalanceDialog'
import CampaignFailDialog from './CampaignFailDialog'
import MUIDataTable from "mui-datatables";
import moment from 'moment';
import debounce from 'lodash/debounce';
import * as mobx from 'mobx'


function isEmpty(obj) {

  if (obj){
    return Object.keys(obj).length === 0 ;
  }
  return true
}

const styles = theme => ({
  root: {
    backgroundColor: '#5DE3FE'
  }
})

//need to show network and price maps sponserships etc
 
const TABLE_COLUMNS = [
 // {name: "campaignCreated",label: "Date",options: {filter: true,sort: true}},
  {name: "campaignName",label: "Name",options: {filter: true,sort: true}},
  {name: "leadType",label: "Lead Type",options: {filter: true,sort: true}},
  {name: "formattedBalance",label: "Balance",options: {filter: true,sort: true}},
  {name: "regionsIncluded",label: "States",options: {filter: true,sort: true}},
  {name: "hasDestination",label: "Delivery",options: {filter: true,sort: true}},
  {name: "formattedQualifiers",label: "Qualifiers", options: {filter: true, sort: true }},
  {name: "formattedContactTypes",label: "Contact Types",options: {filter: true, sort: true}},
  {name: "formattedLeadType",label: "Lead Type",options: {filter: true, sort: true }},
  {name: "id",label: "Campaign Id",options: {filter: true, sort: true, display: 'excluded' }},

]



@inject("commonStore")
@inject("authStore")
@observer
class Campaigns extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      title: 'Campaigns',
      interval: 60000,
      columns: TABLE_COLUMNS,
      loading: false,
      selected: [], 
      showForm: false,
      showSetupForm: false,
      startDate: moment().subtract(190,'day'),
      endDate:  moment(),
      showPurchase: false,
      showCustomDateRange: false,
      showCampaignDialog: false,
      showCampaignFailDialog: false,
    }
  }
  async componentDidMount() {
    console.log('componentDidMount')
    this.getItems()
  }
  setAutoRefresh = () => {
    console.log('setAutoRefresh campaigns')
    const { interval } = this.state
    clearTimeout(this.timer)
    this.timer = setTimeout(this.refreshItems, interval)
  }
  handleDateChange = (type, date) => {

    const temp = {}
    temp[type] = moment(date)
    this.setState(temp)
  }
  toggleCustomDateRange = () => {
    const { showCustomDateRange } = this.state
    this.setState({showCustomDateRange: !showCustomDateRange})
  }

  updateCampaignBalance = debounce((campaign) => {
  //updateCampaignBalance = (campaign) => {
    const {startDate, endDate} = this.state
    const { authStore } = this.props
    const { amount, campaignID, campaignStatus } = campaign

    console.log(amount)

    authStore.updateCampaign({amount, campaignID, campaignStatus}, startDate.format('YYYY-MM-DDTHH:mm:ss.SSSZZ'), endDate.format('YYYY-MM-DDTHH:mm:ss.SSSZZ'))
    .then((result) => {
      if(result){
         this.getItems()
      }else{
         this.setState({showCampaignFailDialog: true})
      }
      this.setState({showCampaignDialog: false})

    })
   }, 1000)
    
  editCampaign = (campaign) => {
    const { selectCampaign } = this.props
    this.setState({showCampaignDialog: false})
    selectCampaign(campaign)
  }
    
  closeCampaignDialog = () => {
    this.setState({showCampaignDialog: false})
  }
  closeCampaignFailDialog = () => {
    this.setState({showCampaignFailDialog: false})
  }

  handleCloseForm = (values) => {
    console.log(values)
      console.log(isEmpty(values))
    if (!(isEmpty(values))){
      const { selectedItem } = this.state
      const updatedItem = {orderID: selectedItem.id, ...values}
      console.log(updatedItem)
    //  this.props.authStore.updateCampaign(updatedItem)
    }
    this.setState({ showForm: false })
  }
  searchStringChanged = (value) => {
    //for initaiting a new queury from the search bar
      console.log(value)
  }

  searchDateUpdated = (type, date) => {
    console.log(type)
    console.log(date)
    const temp = {}
    temp[type] = date
    this.setState(temp, () => {
      this.getItems()
    })
  }
  refreshItems = () => {
    const { authStore } = this.props
    console.log('refreshItems')
    return authStore.getBatchCampaigns()
    .then(result => {
      if(result){
        this.setAutoRefresh()
      }else{
        //need to show auto refresh is off
      }
    })
  }
  getItems = () => {
    const { authStore } = this.props
    console.log('getItems campaigns')
    return authStore.getCampaigns()
    .then(result => {
      if(result){
        this.setAutoRefresh()
      }else{
        //need to show auto refresh is off
      }
    })
  }
  itemSelected = (values) => {
    console.log('itemSelected')

    console.log(values)

    const id = values[values.length - 1] //this form is only made for one item

    const { campaigns } = this.props.commonStore
 

     const foundItems = campaigns.filter(item => {
       return item.id === id
     })

    if (foundItems.length > 0){
      this.setState({showCampaignDialog: true, selectedCampaign: foundItems[0]})
      //selectCampaign(foundItems[0])
    }

  }
  updateItem = (item) => {
    const { selectedItem } = this.state
    //this.props.authStore.updateCampaign(item)
  }

  createDataArray = () => {
    const { columns } = this.state 
    const { campaigns } = this.props.commonStore

  
    return campaigns.map(item => {
   
      const valueArray = []
      for(let column of columns){
        const { name } = column
        valueArray.push(item[name])
      }

      return valueArray
    })
  }
  
  render() {
    const { columns, title, selectedItem, showForm, showSetupForm, startDate, endDate, showCampaignDialog, selectedCampaign, showCampaignFailDialog } = this.state 
    const { classes, commonStore } = this.props
    const { loading, setCampaignRowsPerPage, campaignRowsPerPage, network } = commonStore

    console.log('loading')
    console.log(loading)
    console.log(this.createDataArray())
    
    const campaigns = this.createDataArray()

    const options = {
      //  filterType: 'checkbox',
      selectableRows: false,
      onRowClick:this.itemSelected,
      print: false,
      download: false,
      downloadOptions: false,
      rowsPerPage: campaignRowsPerPage > 0 ? campaignRowsPerPage : campaigns.length,
      onChangeRowsPerPage:setCampaignRowsPerPage
    };

    return (
        <div className={classes.root}>
          <MUIDataTable
          title={'Campaigns'}
          data={campaigns}
          viewColumns={true}
          columns={columns}
          options={options}

        />
        {/*<SonicTable 
        rowData={this.createDataArray()} 
        columnData={columns} 
        title={title} 
        checkbox={false} 
        rowsSelected={this.itemSelected}
        defaultDateRange={{startDate, endDate}}
        searchDateUpdated={this.searchDateUpdated}
        searchDate={this.getItems}
        />*/}
        {showCampaignDialog ? <CampaignBalanceDialog loading={loading} open={showCampaignDialog} campaign={selectedCampaign} update={this.updateCampaignBalance} redirect={() => this.editCampaign(selectedCampaign)} close={this.closeCampaignDialog}/> : null}
        {showCampaignFailDialog ? <CampaignFailDialog close={this.closeCampaignFailDialog} /> : null}
        </div>
      );
    }
  }

  export default withStyles(styles)(Campaigns);

  


// WEBPACK FOOTER //
// ./src/components/Leads/Campaigns/index.js